import Accordion from '@/ReactInit/Scripts/Accordion/Accordion';
import ActorDashboardPage from "@/ReactInit/Scripts/DashboardPage/Actor/ActorDashboardPage";
import AddRating from "@/ReactInit/Scripts/RecipePage/AddRating";
import AdminDashboardPage from "@/ReactInit/Scripts/DashboardPage/Admin/AdminDashboardPage";
import CopyUrlButton from "@/ReactInit/Scripts/CopyUrlButton/CopyUrlButton";
import "@/ReactInit/Scripts/Factblock";
import Navbar from "@/ReactInit/Scripts/Navbar/Default";
import NavbarDashboard from "@/ReactInit/Scripts/Navbar/Dashboard";
import Newsletter from "@/ReactInit/Scripts/Newsletter/Newsletter";
import PowerBI from "@/ReactInit/Scripts/PowerBI/PowerBI";
import RecipeFeedbackForm from "./Scripts/RecipePage/FeedbackForm";
import RecipeIngredients from "@/ReactInit/Scripts/RecipePage/RecipeIngredients";
import RecipePageStarRatingStatic from "@/ReactInit/Scripts/RecipePage/StarRatingStatic";
import Search from "@/ReactInit/Scripts/SearchPage/search";
import SeasonCalendar from "@/ReactInit/Scripts/SeasonCalendar/SeasonCalendar";
import UserInfo from '@/ReactInit/Scripts/Dashboard/UserInfo';
import VideoList from "@/ReactInit/Scripts/VideoPlayer/video";
import WeekMenuCarousel from "@/ReactInit/Scripts/WeekMenuCarousel/WeekMenuCarousel";
import ToTop from '@/ReactInit/Scripts/ToTop/ToTop';
// import ReactTest from '@/ReactInit/Scripts/ReactTest/ReactTest';

export default {
  Accordion,
  ActorDashboardPage,
  AddRating,
  AdminDashboardPage,
  CopyUrlButton,
  Navbar,
  NavbarDashboard,
  Newsletter,
  PowerBI,
  RecipeFeedbackForm,
  RecipeIngredients,
  RecipePageStarRatingStatic,
  Search,
  SeasonCalendar,
  UserInfo,
  VideoList,
  WeekMenuCarousel,
  ToTop
};